import React, { Component } from "react";

import { groupItemsByStation, getItemPresentation, getItemMeatPresentation } from "../../utils/Helpers";

const Item = ({ item, backOrder, showBackOrder, showItemsWithZeroQty }) => {
  const presentation = getItemPresentation(item.item);
  const showItem = showItemsWithZeroQty || item.amount !== 0;
  return (
    showItem && (
      <tr>
        <td>{item ? item.name : ""} {item.grade !== null ? `(Grade: ${item.grade})` : ""}</td>
        <td className="hidden-xs-down">{item && item.inventory ? item.inventory : "-"}</td>
        <td className="hidden-xs-down">{item && item.previous_ordered ? item.previous_ordered : "-"}</td>
        <td>{presentation ? presentation : getItemMeatPresentation(item.item, item.presentation)}</td>
        <td>{item.amount}</td>
        {showBackOrder && <td>{backOrder ? backOrder.back_order_amount : "-"}</td>}
      </tr>
    )
  );
};

class StationItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showItems: true,
    };
  }

  toggleItems = () => {
    this.setState((prevState) => ({
      showItems: !prevState.showItems,
    }));
  };

  render() {
    const { station, items, showBackOrder, backOrder, showItemsWithZeroQty } = this.props;
    const { showItems } = this.state;
    return (
      <tbody>
        <tr className="grouped-table-section-name pointer" onClick={this.toggleItems}>
          <td colSpan={`${showBackOrder ? "6" : "5"}`}>
            <div className="d-flex justify-content-between">
              <span>{station}</span>
              <i className={`fa ${showItems ? "fa-chevron-up" : "fa-chevron-down"}`} />
            </div>
          </td>
        </tr>
        {showItems &&
          items.map((item) => {
            const itemBackOrder = backOrder.detail.find((boItem) => {
              return boItem.id === item.id;
            });
            return (
              <Item
                key={item.id}
                item={item}
                backOrder={itemBackOrder}
                showBackOrder={showBackOrder}
                showItemsWithZeroQty={showItemsWithZeroQty}
              />
            );
          })}
      </tbody>
    );
  }
}

export default class OrderDetail extends Component {
  render() {
    const { order, backOrder, showItemsWithZeroQty, toggleItemsWithZeroQty } = this.props;
    const itemsByStation = groupItemsByStation(order.items);
    const showBackOrder = order.status > 1;
    return (
      <div className="card">
        <div className="card-block p-0">
          <table className="table table-bordered table-striped table-order-station datatable mb-0">
            <thead>
              <tr>
                <th>Item</th>
                <th className="hidden-xs-down">Inventory</th>
                <th className="hidden-xs-down">Previous ordered</th>
                <th className="hidden-xs-down">Presentation</th>
                <th className="hidden-sm-up">Pres</th>
                <th>
                  Qty
                  <i
                    className={`ml-05 mr-0 cursor-pointer fa ${showItemsWithZeroQty ? "fa-eye" : "fa-eye-slash"}`}
                    onClick={toggleItemsWithZeroQty}
                  />
                </th>
                {showBackOrder && <th>Pending</th>}
              </tr>
            </thead>
            {Object.keys(itemsByStation).map((station) => {
              return (
                <StationItems
                  key={station}
                  station={station}
                  items={itemsByStation[station]}
                  showBackOrder={showBackOrder}
                  backOrder={backOrder}
                  showItemsWithZeroQty={showItemsWithZeroQty}
                />
              );
            })}
          </table>
        </div>
      </div>
    );
  }
}
